export default __webpack_public_path__ + "static/media/breast_example_1.984af8fd.png";